import React from "react";
import { IColumn } from "../../../types/uiComponentTypes";
import cn from "classnames";
import { PageGenerator } from "../../../app/uiFunctions/PageGenerator";
import classGenerator from "../../../app/uiFunctions/classGenerator";

export const Column: IColumn = ({
  gap = 0,
  align,
  justify,
  height,
  width,
  className,
  style,
  items,
  context,
}) => {
  return (
    <div
      className={cn(
        "flex",
        "flex-col",
        { [`space-y-${gap}`]: gap },
        classGenerator.justify(justify),
        classGenerator.align(align),
        className,
      )}
      style={{
        ...style,
        ...width,
        ...height,
      }}
    >
      {items?.map((item: any, index: number) => {
        return PageGenerator(
          {
            ...item,
            key: index,
          },
          context,
        );
      })}
    </div>
  );
};
